export const quizActionTypes = {
	SET_LOADING_ERROR: "SET_LOADING_ERROR",
	SET_QUESTION_DATA: "SET_QUESTION_DATA",
	SET_SELECTED_OPTION: "SET_SELECTED_OPTION",
	CHANGE_QUESTION_NUMBER: "CHANGE_QUESTION_NUMBER",
	SET_SCORE: "SET_SCORE",
	END_QUIZ: "END_QUIZ",
	START_QUIZ: "START_QUIZ",
};

export const authActionTypes = {
	SET_AUTH: "SET_AUTH",
	RESET_AUTH: "RESET_AUTH",
	UPDATE_QUIZ_ATTEMPT: "UPDATE_QUIZ_ATTEMPT",
};

export const quizFormModalActionTypes = {
	SET_MODAL_STATE: "SET_MODAL_STATE",
	RESET_MODAL_STATE: "RESET_MODAL_STATE",
	SET_REFETCH_QUIZ: "SET_REFETCH_QUIZ",
};
